import React from 'react';
import { Outlet } from 'react-router-dom';
import { useScrollToHash } from '../../utils/navUtils';
import Header from '../header';
import Footer from '../footer';

function Layout() {
    // Global hash scrolling for all pages
    useScrollToHash();

    return (
        <>
            <Header />
            <main>
                <Outlet />
            </main>
            <Footer />
        </>
    );
}

export default Layout;
